var $ = require('jquery');

var OverviewMap = function OverviewMap($element, options) {
	var mapElement = $('.gmap')[0];

	if(mapElement) {
		var gmap = new google.maps.Map(mapElement, {
			center: {lat: 53.016626, lng: -1.732179},
			zoom: 13,
			scrollwheel: false,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_CENTER
			}
		});

		$.ajax(__CONFIG__.url + 'wp-json/wp/v2/properties/?per_page=100&parent=0', {
			success: function(data) {
				var bounds = new google.maps.LatLngBounds();

				data.forEach(function(mark) {
					var gmark = new google.maps.Marker({
						position: {
							lat: parseFloat(mark.acf.location.lat),
							lng: parseFloat(mark.acf.location.lng)
						},
						map: gmap,
						url: mark.link,
						icon: __CONFIG__.url + 'wp-content/themes/' + __CONFIG__.theme + '/images/custom-pin.png'
					});

					var info = new google.maps.InfoWindow({
						content: '<a href="' + mark.link + '">' + mark.title.rendered + '</a>'
					});

					info.open(gmap, gmark);

					bounds.extend(gmark.getPosition());

					gmark.addListener('click', function() {
						window.location.href = this.url;
					});

					info.addListener('domready', function() {
						var count = 0;
						$('.gm-style-iw').prev().remove().end().each(function() {
							count++;
							var className = '';

							switch(count) {
								case 1:

									className = '-first';

									break;

								case 2:

									className = '-second';

									break;

								case 3:

									className = '-third';

									break;

								case 4:

									className = '-fourth';

									break;
							}

							if(count === 4) {
								count = 0;
							}

							$(this).addClass(className);
						});
					});
				});

				gmap.fitBounds(bounds);
				gmap.panBy(200, 0);
			}
		});
	}
}

module.exports = OverviewMap;